import { render, staticRenderFns } from "./CargoMainFestPop.vue?vue&type=template&id=32ff61e0"
import script from "./CargoMainFestPop.vue?vue&type=script&lang=js"
export * from "./CargoMainFestPop.vue?vue&type=script&lang=js"
import style0 from "./CargoMainFestPop.vue?vue&type=style&index=0&id=32ff61e0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ff61e0')) {
      api.createRecord('32ff61e0', component.options)
    } else {
      api.reload('32ff61e0', component.options)
    }
    module.hot.accept("./CargoMainFestPop.vue?vue&type=template&id=32ff61e0", function () {
      api.rerender('32ff61e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/CargoMainFestPop.vue"
export default component.exports